/**
 * Procedure Categories and Procedures for Diploma in Allergy & Clinical Immunology students
 * Extracted with strict evidence from official NMC PDF
 */
export const ALLERGY_IMMUNOLOGY_PROCEDURES = {
  "Allergy Diagnostics & Skin Testing": [
    "Allergy Skin Prick Testing & Intradermal Testing",
    "Patch Testing for Contact Allergies",
    "In-Vitro Serum IgE & Allergen-Specific IgE Assays",
    "Pulmonary Function Testing (Spirometry & PEFR)",
  ],
  "Therapeutic Immunotherapy & Interventions": [
    "Allergen Immunotherapy (Subcutaneous & Sublingual Immunotherapy)",
    "Allergen & Drug Provocation Challenge Testing",
  ],
};

export const ALLERGY_IMMUNOLOGY_CATEGORIES = Object.keys(ALLERGY_IMMUNOLOGY_PROCEDURES);

export const isDiplomaInAllergyImmunologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("allergy") ||
    (d.includes("clinical immunology") && d.includes("allergy")) ||
    (d.includes("immunology") && d.includes("allergy"))
  );
};
